import { render, staticRenderFns } from "./creditNotes.vue?vue&type=template&id=9f67651e&scoped=true&"
import script from "./creditNotes.vue?vue&type=script&lang=js&"
export * from "./creditNotes.vue?vue&type=script&lang=js&"
import style0 from "./creditNotes.vue?vue&type=style&index=0&id=9f67651e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f67651e",
  null
  
)

export default component.exports